var paddingByNestedLevel = nestedLevel => {
  switch (nestedLevel) {
    case 1:
      return 's';

    case 2:
      return 'xl';

    default:
      return 'none';
  }
};

export var selectOptionTheme = {
  baseStyle: _ref => {
    var {
      isSelected,
      isFocused,
      data
    } = _ref;
    return {
      optionContainer: {
        paddingLeft: paddingByNestedLevel(data.nestedCount),
        transition: 'background-color 0.1s ease-in-out',
        display: 'flex',
        alignItems: 'center',
        py: 's',
        ':hover': {
          bgColor: 'neutral.lightest',
          cursor: 'pointer'
        },
        bgColor: isSelected ? 'neutral.lighter' : isFocused ? 'neutral.lightest' : 'inherit'
      },
      option: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row'
      },
      iconStyle: {
        display: 'inline-flex',
        color: 'neutral.dark'
      },
      textContainer: {
        display: 'flex',
        flexDirection: 'column',
        px: 's'
      },
      optionText: {
        textStyle: 'body3'
      },
      descriptionText: {
        textStyle: 'body4',
        color: 'neutral.darker',
        marginTop: 'xxs'
      }
    };
  }
};
//# sourceMappingURL=SelectOption.theme.js.map